module.exports = __webpack_public_path__ + "static/jIMMY_2014-503b6e502333b0e41b638cabbf94560e.mp4";